import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ContactManager from './ContactManager';
import { get } from 'lodash';
import * as asyncActionCreator from '../../../../redux/actionCreators/async';

@connect((store, props) => ({
  user: store.user,
  contacts: get(store.admin, 'contactInContactWorksheet', {}),
  route: {
    params: props.params,
    query: props.location.query
  } // actually being from from react-redux-router to regular props
}))
export default class ContactsDashboard extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    route: PropTypes.object,
    location: PropTypes.object,
    query: PropTypes.object,
    params: PropTypes.object, // comes from react-redux-router
    user: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);
  }

  searchContacts(terms = [], filters = {}, skip, limit) {
    this.props.dispatch(asyncActionCreator.searchContacts(terms, filters, skip, limit));
  }

  render() {
    return (
      <div className='contact-dashboard'>
        <ContactManager
          selectedContactId={this.props.route.params.contactId}
          minWidth='1700px'
          searchContacts={::this.searchContacts}
          location={this.props.location.pathname}
        />
        {
          this.props.children
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Dashboard/index.js